<template>
  <div>
    <v-card
    outlined>
      <v-card-title :bind="title" class="light-blue--text justify-space-between">
        <h3 class="headline" v-text="title"></h3>
        <v-btn aria-label="Delete This Reminder" small v-if="!isNew" @click="deleteDialog = true" icon color="grey">
          <v-icon >mdi-delete</v-icon>
        </v-btn>
      </v-card-title>
      <div class="pa-4">
        <template v-if="reminderLoading || loading">
          <div class="text-center">
            <v-progress-circular color="light-blue" indeterminate/>
          </div>
        </template>
        <div v-else>
          <v-form
            ref="form"
            v-model="formValid"
          >
            <v-row>
              <v-col cols="12" md="9" class="pt-0">
                <div class="font-weight-bold text-uppercase mb-1">Address</div>
                  <v-select class="rounded-0"
                          v-model="propertyID"
                          :items="selectData"
                          hide-details
                          color="light-blue"
                          item-color="light-blue"
                            :rules="notEmptyRules"
                            filled
                          outlined
                          dense
                          label="Property Address"
                          required
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="4" class="pb-0">
                <v-dialog
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  :return-value.sync="date"
                  persistent
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <div class="font-weight-bold text-uppercase mb-1">Due Date</div>
                    <v-text-field class="rounded-0"
                                  v-model="date"
                                  color="light-blue"
                                  filled
                                  dense
                                  outlined
                                  readonly
                                  label="Due Date"
                                  v-bind="attrs"
                                  v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    header-color="light-blue"
                    color="light-blue"
                    v-model="date"
                    scrollable
                  >
                    <v-spacer></v-spacer>
                    <v-btn elevation="0" @click="menu = false">Cancel</v-btn>
                    <v-btn elevation="0" dark color="light-blue" @click="$refs.menu.save(date)">OK</v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-0" cols="12">
                <div class="font-weight-bold text-uppercase mb-1">Notes</div>
                <v-textarea class="rounded-0"
                            label="Notes"
                            required
                            :rules="notEmptyRules"
                            v-model="text"
                            dense
                            filled
                            color="light-blue"
                            outlined
                ></v-textarea>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-0 " cols="12" lg="7" xl="5">
                <div class="font-weight-bold text-uppercase mb-0">Set Status</div>
                <v-switch color="light-blue" class="mt-0" v-model="complete" :label="`${complete ? 'Complete' : 'Incomplete'}`"></v-switch>
              </v-col>
            </v-row>
            <v-row justify="end">
              <v-col cols="12" :sm="4" :md="5" :xl="4">
                <v-btn
                  :disabled="!formValid"
                  block
                  @click="saveReminder(reminderID)"
                  :dark="formValid"
                  color="light-blue"
                  small
                  elevation="0"
                  tile
                >
                  {{isNew ? 'Save' : 'Update'}} Reminder
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </div>
      </div>
    </v-card>

    <v-dialog
      v-model="deleteDialog"
      max-width="400"
    >
      <v-card>
        <v-card-title class="headline">Delete This Reminder?</v-card-title>

        <v-card-text>
          Deleting a reminder cannot be undone.
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="grey darken-1"
            text
            @click="deleteDialog = false"
          >
            Cancel
          </v-btn>

          <v-btn
            color="red darken-1"
            text
            @click="confirmDelete(reminderID)"
          >
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


  </div>
</template>

<script>
  import moment from 'moment';
  import { mapActions, mapGetters } from "vuex";
  export default {
    name: 'ManageReminder',
    computed:{
      isNew() {
        return (this.$props.id === null);
      },
      title() {
        let title = (this.isNew === true) ? 'Add New' : 'Edit';
        return title + ' Reminder';
      },
      ...mapGetters(['properties', 'reminder', 'accountID', 'reminderID', 'propertiesLoading', 'reminderLoading']),
      selectData(){
        let list = [{
          text:'Select an Address',
          value:null
        }];
        Object.keys(this.properties).forEach((property) => {
          list.push({
            text: this.getFullAddress(property),
            value: property
          })
        })
        return list;
      },
      formData(){
        return{
          propertyID: this.propertyID,
          date: moment(this.date).toDate(),
          text: this.text,
          accountID: this.accountID,
          complete: this.complete,
        }
      }
    },

    data: () => ({
      formValid: false,
      loading: false,
      menu: false,
      deleteDialog: false,
      propertyID: null,
      date: new Date().toISOString().substr(0, 10),
      text: '',
      complete: false,
      notEmptyRules: [
        v => !!v || 'This Field is Required',
      ],

    }),
    props:{
      id: {
        type: String,
        default: null
      },
    },
    created(){
      this.initialize();
    },
    watch: {
      'reminderID': function () {
        this.initialize();
      },
      'reminder': function () {
        this.initialize();
      },
    },

    methods: {
      initialize(){
        this.loading = true;
        if (this.reminderID){
          this.propertyID = this.reminder.propertyID;
          this.date = moment(this.reminder.date.toDate()).format('YYYY-MM-DD');
          this.text = this.reminder.text;
          this.complete = this.reminder.complete;
        } else {
          this.propertyID = null;
          this.date = moment().format('YYYY-MM-DD');
          this.text = null;
          this.complete = false;
        }
        this.loading = false;

      },
      async saveReminder(){
        if (!this.isNew && this.reminderID){
          await this.updateReminder(this.formData);
        } else {
          try {
            await this.addNewReminder(this.formData);
            await this.$router.push('/reminders/'+this.reminderID);
          } catch (e){
            console.log(e)
          }
        }
      },

      getFullAddress(property){
        return `${this.properties[property].addressLineOne}, ${this.properties[property].city} ${this.properties[property].state}, ${this.properties[property].zip}`
      },
      async confirmDelete(id){
        await this.deleteReminder(id);
        this.deleteDialog = false;
      },
      ...mapActions([
        'addNewReminder',
        'updateReminder',
        'deleteReminder',
      ]),


    }
  }
</script>

<style lang="scss" scoped>
</style>